import React from "react";
import { useField } from "formik";
import styled from "styled-components";

const businessTypeOptions = [
  { value: 0, label: "개인" },
  { value: 1, label: "법인" },
];

const SelectBusinessType = ({ label, disabled, ...props }) => {
  const [field, { value }, { setValue }] = useField(props);

  const handleSelect = (e) => {
    if (disabled) return;
    e.stopPropagation();
    setValue(e.target.value);
  };

  const renderOptions = () => {
    return businessTypeOptions.map((option) => {
      return (
        <Option
          type="button"
          key={option.value}
          value={option.value}
          onClick={handleSelect}
          className={option.value === Number(value) ? "selected" : ""}
        >
          {option.label}
        </Option>
      );
    });
  };

  return (
    <Wrapper>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      <ButtonsWrapper disabled={disabled}>{renderOptions()}</ButtonsWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  text-align: left;
  color: ${(props) => props.theme.colors.inputLabel};
  margin-bottom: 8px;
  line-height: 18px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 4px;
  background-color: ${(props) =>
    props.disabled ? "var(--disabled)" : "#f1f4fb"};
  border-radius: 8px;
`;

const Option = styled.button`
  font-size: 16px;
  line-height: 24px;
  color: #9a9ea8;
  display: inline-block;
  flex: 1;
  border: none;
  background-color: inherit;

  &.selected {
    background-color: #ffffff;
    border-radius: 4px;
    color: ${(props) => props.theme.colors.primaryTextColor};
    font-weight: 600;
  }
`;

export default SelectBusinessType;
